module.exports = __webpack_public_path__ + "img/Octocat-ironcat.82b80cb2.png";